export const colors = {
  fadedBlack: "rgba(0, 0, 0, 0.5)",
  iosBlur: " transparent",
};

//!FLEX CENTER ALL
export const flexCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

//!FLEX CENTER SPACE-BETWEEN
export const flexCenterSpaceBetwn = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};



export const BoxShadow = {
  boxShadow: "0 10px 15px rgb(0 0 0 / 20%);",
};
//!Font Families

export const fontFamily = {
dosis: "'Dosis', sans-serif",
roboto: "'Roboto', sans-serif",
logo: "'Rubik Iso', cursive",
numbers: "'Archivo Black', sans-serif"
}


